module.exports = __webpack_public_path__ + "img/t_3.c30c4f86.png";